import { useEffect, useState } from 'react';
import api from './api';

// Módulos da conta que podem ser ligados/desligados em Configurações → Módulos.
export interface AccountModules {
  liveAutomation: boolean;
  contacts: boolean;
}

export const MODULE_DEFAULTS: AccountModules = { liveAutomation: true, contacts: true };
const EVENT = 'account-modules-changed';
let cache: AccountModules | null = null;
let inflight: Promise<AccountModules> | null = null;

export async function fetchAccountModules(force = false): Promise<AccountModules> {
  if (cache && !force) return cache;
  if (!inflight || force) {
    inflight = api
      .get('/account-modules')
      .then((r) => (cache = { ...MODULE_DEFAULTS, ...(r.data?.data || {}) }))
      .catch(() => MODULE_DEFAULTS)
      .finally(() => {
        inflight = null;
      }) as Promise<AccountModules>;
  }
  return inflight;
}

export async function saveAccountModules(patch: Partial<AccountModules>): Promise<AccountModules> {
  const r = await api.put('/account-modules', patch);
  const next: AccountModules = { ...MODULE_DEFAULTS, ...(r.data?.data || {}) };
  cache = next;
  window.dispatchEvent(new Event(EVENT));
  return next;
}

// null enquanto carrega (para não piscar itens do menu).
export function useAccountModules(): AccountModules | null {
  const [mods, setMods] = useState<AccountModules | null>(cache);
  useEffect(() => {
    let alive = true;
    fetchAccountModules().then((m) => alive && setMods(m));
    const onChange = () => setMods(cache);
    window.addEventListener(EVENT, onChange);
    return () => {
      alive = false;
      window.removeEventListener(EVENT, onChange);
    };
  }, []);
  return mods;
}
